module.exports = __webpack_public_path__ + "img/L 09.f0a57632.png";